import {
  LOADING_SHOW,
  LOADING_HIDE,
  LOADING_REQUEST_INCREASE,
  LOADING_REQUEST_RELEASE,
} from '../mutation-types';


// state
const localState = {
  loading: false,
  requestCount: 0,
};

// mutations
const mutations = {
  [LOADING_SHOW](state) {
    state.loading = true;
  },
  [LOADING_HIDE](state) {
    state.loading = false;
  },
  [LOADING_REQUEST_INCREASE](state) {
    state.requestCount += 1;

    if (state.requestCount > 0) {
      state.loading = true;
    }
  },
  [LOADING_REQUEST_RELEASE](state) {
    state.requestCount -= 1;

    if (state.requestCount < 0) {
      state.requestCount = 0;
    }

    if (state.requestCount === 0) {
      state.loading = false;
    }
  },
};

// actions
const actions = {

};

export default {
  state: localState,
  mutations,
  actions,
};
